/* eslint-disable react/destructuring-assignment */
import { useContext, useMemo } from 'react';
import { getSellConfigFromProps } from '../helpers';
import type { MoonPaySellProps } from '../types';
import { MoonPayContext } from './MoonPayProvider';
import { MoonPayWidget } from './MoonPayWidget';

export function MoonPaySellWidget(props: MoonPaySellProps) {
  const { apiKey, environment } = useContext(MoonPayContext);

  const config = useMemo(
    () =>
      getSellConfigFromProps({
        props,
        apiKey,
        environment,
        debug: false,
        signature: props.signature || '',
      }),
    [props, apiKey, environment],
  );

  return (
    <MoonPayWidget
      config={config}
      visible={props.visible}
      onUrlSignatureRequested={props.onUrlSignatureRequested}
      className={props.className}
      style={props.style}
    />
  );
}
